/* global __webpack_nonce__ */ // eslint-disable-line no-unused-vars

// CSP: Set a special variable to add `nonce` attributes to all styles/script tags
// See https://github.com/webpack/webpack/pull/3210 
__webpack_nonce__ = "@ViewBag.nonce"; // eslint-disable-line no-undef